/**
 * A yes/no dialog for an action that changes something: revoke, remove a
 * source. The body says what will happen; the confirm button carries the
 * verb. Lifted from the Clients page (task 69); task 83's Response panel
 * uses it too.
 */

import type { ReactNode } from 'react';

import { PillButton } from '@bluesphere/ui-kit';

import { ErrorNote, ModalShell } from '@bluesphere/mdr-alert-panel';

export function ConfirmModal({
  title,
  confirmLabel,
  pendingLabel,
  onCancel,
  onConfirm,
  isPending,
  error,
  children,
}: {
  title: string;
  confirmLabel: string;
  pendingLabel: string;
  onCancel: () => void;
  onConfirm: () => void;
  isPending: boolean;
  error: unknown;
  children: ReactNode;
}) {
  return (
    <ModalShell onClose={onCancel}>
      <div className="border-b border-bluesphere-border px-6 py-5">
        <h2 className="text-lg font-semibold text-bluesphere-textOnLight">{title}</h2>
      </div>
      <div className="space-y-3 px-6 py-5">
        {children}
        <ErrorNote error={error} />
      </div>
      <div className="flex items-center justify-end gap-2 border-t border-bluesphere-border px-6 py-3">
        <PillButton variant="ghost" size="sm" onClick={onCancel}>
          Cancel
        </PillButton>
        <PillButton size="sm" onClick={onConfirm} disabled={isPending}>
          {isPending ? pendingLabel : confirmLabel}
        </PillButton>
      </div>
    </ModalShell>
  );
}
